import { useState } from 'react';
import styled from 'styled-components';
import { InfoIcon } from '../../../../../../generic/components/icons/info-icon';
import { BouCheckBoxWithLabel } from '../../../../../../generic/components/inputs/bou-check-box-with-label';
import { getTextStyle } from '../../../../../../generic/content/texts/bou-text/text-style';
import { ValueChainsModal } from '../../../../framework/value-chains-modal';

interface Props {
  showValueChains: boolean;
  setShowValueChains: (mode: boolean) => void;
}

export function ValueChainsSwitch(props: Props) {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <Root>
      <BouCheckBoxWithLabel
        label="Show value chains"
        checked={props.showValueChains}
        onChange={(checked: boolean) => props.setShowValueChains(checked)}
      />
      <div>
        <div onClick={() => setModalVisible(true)}>
          <InfoIcon style={{ fontSize: 18, paddingLeft: 11, cursor: 'pointer' }} />
        </div>
        <ValueChainsModal isModalOpen={modalVisible} closeModal={() => setModalVisible(false)} />
      </div>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  ${getTextStyle({ size: 'xxxs' })}
`;
